var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWindPower02 = function SvgWindPower02(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "wind-power-02_svg__svg-icon"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#wind-power-02_svg__a)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m11.686 9.906.021-.007.011-.004a1.052 1.052 0 0 1 .598.008L12.313 3.8c0-.148-.073-.312-.163-.362-.089-.05-.18.029-.202.176l-.76 5.094a.904.904 0 0 0 .094.5l.404.698Zm-.375 1.787a1.044 1.044 0 0 1-.314-.486l-5.332 3.097c-.128.074-.231.218-.231.322.002.102.116.141.254.086l4.787-1.898a.904.904 0 0 0 .385-.334l.448-.779.001-.004.002-.004Zm.689.259c.151 0 .294-.032.424-.09l.004.106.37 8.41s-.331.194-.798.194-.798-.195-.798-.195l.348-7.926.006-.13.02-.459c.13.058.273.09.424.09Zm6.376 2.512-4.031-3.204a.906.906 0 0 0-.481-.168h-.833c-.039.21-.14.4-.286.547l5.287 3.048c.129.074.306.092.394.04.089-.052.066-.171-.05-.263ZM12 11.352a.448.448 0 1 1 0-.895.448.448 0 0 1 0 .895Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "wind-power-02_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h24v24H0z"
  })))));
};
export { SvgWindPower02 as ReactComponent };